import React, { useEffect, useState } from "react";
import {
  GroupOutlined,
  FileOutlined,
  BellOutlined,
  SettingOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  UserOutlined,
  DownOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import {
  Avatar,
  Badge,
  Popover,
  Button,
  Col,
  Layout,
  List,
  Row,
  Space,
  theme,
  Descriptions,
  Typography,
  Flex,
  Dropdown,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { dologout, sessionVerifyApi } from "../security/slice-login";
import { getAllMasterType } from "./slice-master";
import Title from "antd/es/typography/Title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCog, faUserAlt } from "@fortawesome/free-solid-svg-icons";

function parseJwt(token: any) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

const { Header } = Layout;
const { Text, Link } = Typography;

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

const HeaderComponent = ({ setCollapsed, collapsed }: any) => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [openNotification, setOpenNotification] = useState(false);
  const [openUserProfile, setOpenUserProfile] = useState(false);
  const [openSettingsChanges, setOpenSettingsChanges] = useState(false);
  const [openUserInfo, setOpenUserInfo] = useState(false);

  const handleOpenUserProfileChange = (open: boolean) => {
    setOpenUserProfile(open);
  };

  const handleNotificationOpenChange = (open: boolean) => {
    setOpenNotification(open);
  };

  const handleOpenSettingsChange = (newOpen: boolean) => {
    setOpenSettingsChanges(newOpen);
  };

  const hadleOpenUserInfo = (newOpen: boolean) => {
    setOpenUserInfo(newOpen);
  };

  //check for login token and redirect to login
  const { userinfo, data } = useSelector((state: any) => state.login);
  useEffect(() => {
    if (!data || data.lenght < 0) nav("/home/booking");
  }, [data]);
  useEffect(() => {
    dispatch(getAllMasterType());
  }, []);
  //call session verify api
  useEffect(() => {
    dispatch(sessionVerifyApi());
    const intervalId = setInterval(() => {
      dispatch(sessionVerifyApi());
    }, 150000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const items: MenuProps["items"] = [
    {
      label: (
        <Button
          href="#/home/userSettings/"
          shape="round"
          color="primary"
          variant="outlined"
          className="menu-button w-100"
        >
          Profile Detail
        </Button>
      ),
      key: "0",
    },
    {
      label: (
        <Button
          href="#/home/profile/agentProfile/"
          shape="round"
          color="primary"
          variant="outlined"
          className="menu-button w-100"
        >
          Agent Profile
        </Button>
      ),
      key: "1",
    },
    {
      label: (
        <Button
          href="#/home/profile/subUserProfile"
          shape="round"
          color="primary"
          variant="outlined"
          className="menu-button w-100"
        >
          Sub User Profile
        </Button>
      ),
      key: "2",
    },
  ];

  const menuProps = { items };
  const notificationData = [
    "Racing car sprays burning fuel into crowd.",
    "Japanese princess to wed commoner.",
    "Australian walks 100km after outback crash.",
    "Man charged over missing wedding girl.",
    "Los Angeles battles huge wildfires.",
  ];
  return (
    <Header style={{ background: colorBgContainer }}>
      <Row className="position-relative mrl-0 h-100">
        <Col xs={2} xl={2} className="sliderButton">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />
        </Col>
        <Col xs={2} xl={0} className="LogoMobileView">
          <span></span>
        </Col>
        <Col xs={20} xl={22} className="rightHeaderIcons h-100">
          <Dropdown menu={menuProps} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Avatar
                size={"large"}
                className="iconAvatar"
                shape="circle"
                icon={<FontAwesomeIcon icon={faUserAlt} />}
              />
            </a>
          </Dropdown>
          <Popover
            title="Notifications"
            content={
              <>
                <List
                  size="small" 
                  bordered = {false}
                  dataSource={notificationData}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                />
              </>
            }
            trigger="click"
            open={openNotification}
            onOpenChange={handleNotificationOpenChange}
          >
            <Badge count={1}>
              <Avatar
                size={"large"}
                className="iconAvatar"
                shape="circle"
                icon={<FontAwesomeIcon icon={faBell} />}
              />
            </Badge>
          </Popover>

          <Popover
            title="Settings"
            content={
              <>
                 <List
                  size="small" 
                  bordered = {false}
                  dataSource={notificationData}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                />
              </>
            }
            trigger="click"
            open={openSettingsChanges}
            onOpenChange={handleOpenSettingsChange}
          >
            <Avatar
              className="iconAvatar"
              size={"large"}
              shape="circle"
              icon={<FontAwesomeIcon icon={faCog} />}
            />
          </Popover>

          <Popover
            title="Profile"
            content={
              <>
                <Descriptions style={{ width: "244px" }} column={1}>
                  <Descriptions.Item label="Email">
                    {userinfo?.email}
                  </Descriptions.Item>
                  <Descriptions.Item label="Role">
                    {userinfo?.userRole}
                  </Descriptions.Item>
                </Descriptions>
                <Button
                  type="text"
                  icon={<LogoutOutlined />}
                  onClick={() => {
                    dispatch(dologout(""));
                  }}
                >
                  Logout
                </Button>
              </>
            }
            trigger="click"
            open={openUserInfo}
            onOpenChange={hadleOpenUserInfo}
          >
            <Flex align="center" justify="center">
              <Flex align="start" vertical>
                <Title level={5} className="mt-0 mb-0">
                  Welcome!
                </Title>
                <Title level={5} className="mt-0 mb-0">
                  {" "}
                  {userinfo?.userName}{" "}
                </Title>
              </Flex>
              <CaretDownOutlined className="ml-2" />
            </Flex>
          </Popover>
        </Col>
      </Row>
    </Header>
  );
};
export { HeaderComponent };
